export default __webpack_public_path__ + "static/media/may2024-5.83840c6e.jpg";